import "../../style/components/GameSelectModal.scss";

import { IonButton, IonButtons, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { setActiveGame, setModalVisibility } from "../actions";
import { allCharacterLists } from "../constants/gamedetails/characterLists";
import { GAME_NAMES } from "../constants/ImmutableGameDetails";
import { modalVisibilitySelector, modeNameSelector, selectedCharactersSelector } from "../selectors";

const GameSelectModal = () => {
  const modalVisibility = useSelector(modalVisibilitySelector);
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedCharacters = useSelector(selectedCharactersSelector);
  const modeName = useSelector(modeNameSelector);

  const handleModalDismiss = () => {
    modalVisibility.visible && dispatch(setModalVisibility({ currentModal: "gameSelect", visible: false }));
  };

  return (
    <IonModal
      isOpen={modalVisibility.visible && modalVisibility.currentModal === "gameSelect"}
      onDidDismiss={handleModalDismiss}
      id="GameSelectModal"
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={() => dispatch(setModalVisibility({ currentModal: "gameSelect", visible: false }))}>Close</IonButton>
          </IonButtons>
          <IonTitle>Game Select</IonTitle>
        </IonToolbar>
      </IonHeader>
      <div className="game-buttons">
        {GAME_NAMES.map(gameName => 
          <button key={gameName} onClick={() => {
            dispatch(setActiveGame(gameName, true));
            if (modeName === "home") {
              history.push(`/framedata/${gameName}/${allCharacterLists[gameName].includes(selectedCharacters["playerOne"].name) ? selectedCharacters["playerOne"].name : allCharacterLists[gameName][0]}`);
            } else if (modeName === "framedata" || modeName === "moveslist" || modeName === "combos") {
              history.replace(`/${modeName}/${gameName}/${allCharacterLists[gameName].includes(selectedCharacters["playerOne"].name) ? selectedCharacters["playerOne"].name : allCharacterLists[gameName][0]}`);
            }
            handleModalDismiss();
          }}>
            <img src={`https://fullmeter.com/fatassets/img/logos/${gameName}-logo.png`} />
          </button>
        )}
      </div>
    </IonModal>
  );
};

export default GameSelectModal;
